import PropTypes from 'prop-types';

const getState = (index, current) => {
  if (index < current) return 'complete';
  if (index === current) return 'current';
  return 'upcoming';
};

const CIRCLE_CLASSES = {
  complete: 'bg-white border-primary-700 text-primary-700',
  current: 'bg-primary-800 border-primary-800 text-white',
  upcoming: 'bg-white border-neutral-300 text-neutral-400',
};

const LABEL_CLASSES = {
  complete: 'text-neutral-800',
  current: 'text-primary-800 font-semibold',
  upcoming: 'text-neutral-400',
};

const lineColor = (isActive) => (isActive ? 'bg-primary-700' : 'bg-neutral-200');

const CheckoutStepper = ({ steps, current, className = '' }) => (
  <ol className={`flex w-full min-w-0 list-none m-0 p-0 ${className}`}>
    {steps.map(({ label }, index) => {
      const state = getState(index, current);
      const isFirst = index === 0;
      const isLast = index === steps.length - 1;

      return (
        <li
          key={`${index}-${label}`}
          data-state={state}
          aria-current={state === 'current' ? 'step' : undefined}
          className='relative flex flex-1 min-w-0 flex-col items-center'
        >
          {!isFirst && (
            <span
              aria-hidden='true'
              className={`absolute top-[17px] left-0 right-1/2 mr-[18px] h-[1.5px] ${lineColor(index <= current)}`}
            />
          )}
          {!isLast && (
            <span
              aria-hidden='true'
              className={`absolute top-[17px] left-1/2 right-0 ml-[18px] h-[1.5px] ${lineColor(index < current)}`}
            />
          )}
          <span
            className={`relative z-[1] flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-[1.5px] text-sm font-semibold ${CIRCLE_CLASSES[state]}`}
          >
            {index + 1}
          </span>
          <span
            className={`mt-2 whitespace-nowrap text-center text-[13px] leading-tight ${LABEL_CLASSES[state]}`}
          >
            {label}
          </span>
        </li>
      );
    })}
  </ol>
);

CheckoutStepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
  })).isRequired,
  current: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default CheckoutStepper;
